<template>
  <div id="error-404-screen">
    <div class="img">
      <img src="/static/icons/404-error-icon.svg" />
    </div>
    <div class="title">
      <h3 v-html="$t('errorPage.title')"></h3>
    </div>
    <div class="text">
      <h5>{{ $t("errorPage.text") }}</h5>
    </div>
    <div class="back-button">
      <rounded-button @click="backToMainPage" width="100%">
        {{ $t("errorPage.button.text") }}
      </rounded-button>
    </div>
  </div>
</template>
<script>
export default {
  name: "Error404Screen",
  methods: {
    backToMainPage() {
      this.$router.replace("/");
    }
  }
};
</script>
<style lang="scss" scoped>
@import "~@/styles/variables.scss";
#error-404-screen {
  max-width: 500px;
  margin: auto;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 20px;
  color: #5a5a5a;
  .img {
    width: 150px;
  }
  .title {
    text-align: center;
    h3 {
      margin-bottom: 10px !important;
    }
  }
  .text {
    text-align: center;
    h5 {
      margin-top: 10px !important;
      font-weight: 550;
    }
  }
  .back-button {
    width: 100%;
  }
}
</style>
